// extracted by mini-css-extract-plugin
export default {"stateLabel":"HeaderState-module__stateLabel--r_Sbk","duplicateIssueLink":"HeaderState-module__duplicateIssueLink--LUxYA"};